/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EnumValue } from './EnumValue';
import {
    EnumValueFromJSON,
    EnumValueFromJSONTyped,
    EnumValueToJSON,
} from './EnumValue';

/**
 * 
 * @export
 * @interface MappableField
 */
export interface MappableField {
    /**
     * 
     * @type {string}
     * @memberof MappableField
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MappableField
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MappableField
     */
    type: MappableFieldTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MappableField
     */
    required: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MappableField
     */
    requiredOnCreate?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MappableField
     */
    targetEntitySets?: Array<string>;
    /**
     * 
     * @type {Array<EnumValue>}
     * @memberof MappableField
     */
    options?: Array<EnumValue>;
    /**
     * 
     * @type {boolean}
     * @memberof MappableField
     */
    integerOnly?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MappableField
     */
    maxLength?: number;
}


/**
 * @export
 */
export const MappableFieldTypeEnum = {
    String: 'string',
    Date: 'date',
    Enum: 'enum',
    Number: 'number',
    Lookup: 'lookup'
} as const;
export type MappableFieldTypeEnum = typeof MappableFieldTypeEnum[keyof typeof MappableFieldTypeEnum];


/**
 * Check if a given object implements the MappableField interface.
 */
export function instanceOfMappableField(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "required" in value;

    return isInstance;
}

export function MappableFieldFromJSON(json: any): MappableField {
    return MappableFieldFromJSONTyped(json, false);
}

export function MappableFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): MappableField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'type': json['type'],
        'required': json['required'],
        'requiredOnCreate': !exists(json, 'requiredOnCreate') ? undefined : json['requiredOnCreate'],
        'targetEntitySets': !exists(json, 'targetEntitySets') ? undefined : json['targetEntitySets'],
        'options': !exists(json, 'options') ? undefined : ((json['options'] as Array<any>).map(EnumValueFromJSON)),
        'integerOnly': !exists(json, 'integerOnly') ? undefined : json['integerOnly'],
        'maxLength': !exists(json, 'maxLength') ? undefined : json['maxLength'],
    };
}

export function MappableFieldToJSON(value?: MappableField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'type': value.type,
        'required': value.required,
        'requiredOnCreate': value.requiredOnCreate,
        'targetEntitySets': value.targetEntitySets,
        'options': value.options === undefined ? undefined : ((value.options as Array<any>).map(EnumValueToJSON)),
        'integerOnly': value.integerOnly,
        'maxLength': value.maxLength,
    };
}

